import React from 'react';
import {browserHistory} from 'react-router';

const buyerStateBreakdownRoute = '/buyer-state-breakdown';
const transactionBreakdownRoute = '/transaction-breakdown';
const marketTransactionBreakdownRoute = '/market-transaction-breakdown';
const listRoute = '/list';

export default class Filter extends React.Component {
	constructor(props) {
		super(props);
		const query = {...this.props.location.query};

		this.state = {
			query,
			paneIndex: 0,
            buyerStateBreakdownCheckbox: false,
            transactionBreakdownCheckbox: false,
            marketTransactionBreakdownCheckbox: false,
            isBreakdown: false,
		};

		this.clear = this.clear.bind(this);
		this.close = this.close.bind(this);
		this.setValue = this.setValue.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.getValuesForDropdown = this.getValuesForDropdown.bind(this);
		this.handleBreakdownChange = this.handleBreakdownChange.bind(this);
		this.navigateTo = this.navigateTo.bind(this);
    }

    static getDefaultQuery(page) {
		if (!page) {
			return {
                SOURCE: 'STRIVE',
                STATUS: 'Active',
				TRANSACTION_TYPE: 'Investment Sales'
			}
		}

        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth()+1;
        const currentDay = today.getDate();
        const baseMin = `1/1/${currentYear}`;
        const baseMax = `${currentMonth}/${currentDay}/${currentYear}`;
        const comparisonMin = `1/1/${currentYear-1}`;
        const comparisonMax = `12/31/${currentYear-1}`;

        switch (page) {
			case 'buyerStateBreakdown':
                return {
                    SOURCE: 'STRIVE',
                    STATUS: 'Closed',
                    BASE_MIN: baseMin,
                    BASE_MAX: baseMax,
                    COMPARISON_MIN: comparisonMin,
                    COMPARISON_MAX: comparisonMax,
				};
			case 'transactionBreakdown':
                return {
                	STATE: 'TX',
                	TYPE: 'STNL',
                    STATUS: 'Closed',
					CATEGORY: 'retail',
                    TRANSACTION_YEAR: currentYear,
                };
            case 'marketTransactionBreakdown':
                return {
                    STATE: 'TX',
                    STATUS: 'Closed',
                    CATEGORY: 'retail',
					MARKET: 'DFW',
                    TRANSACTION_YEAR: currentYear,
                };
        }
    }

	handleSubmit(e) {
		e.preventDefault();

		const query = {...this.state.query};
		const isBreakdown = this.state.isBreakdown;
        const buyerStateBreakdownCheckbox = this.state.buyerStateBreakdownCheckbox;
        const transactionBreakdownCheckbox = this.state.transactionBreakdownCheckbox;
        const marketTransactionBreakdownCheckbox = this.state.marketTransactionBreakdownCheckbox;

		// Remove blank values
		Object.keys(query).forEach(key => {
			if (!query[key]) {
				delete query[key];
			}
		});

		window.scrollTo(0, 0);

		// if Buyer State or Transaction Breakdowns are activated
        if (buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox) {
            browserHistory.push({
                pathname: buyerStateBreakdownCheckbox ? buyerStateBreakdownRoute : transactionBreakdownCheckbox ? transactionBreakdownRoute : marketTransactionBreakdownRoute,
                query,
            });
            return;
        }

        // if Buyer State or Transaction Breakdowns are deactivated
        if (isBreakdown && (!buyerStateBreakdownCheckbox && !transactionBreakdownCheckbox && !marketTransactionBreakdownCheckbox)) {
        	this.setState({isBreakdown: !isBreakdown});
            browserHistory.push({
                pathname: listRoute,
                query,
            });
            return;
        }

        // if STATUS = 'Under Contract' sort properties desc by EFFECTIVE_DATE
        if (query.STATUS === 'Under Contract,')
            query.order = 'EFFECTIVE_DATE.desc';
        if (query.STATUS !== 'Under Contract,' && query.order)
            if (Array.isArray(query.order)) {
                const index = query.order.indexOf('EFFECTIVE_DATE.desc');
                if (index > -1) query.order.splice(index, 1);
            } else delete query.order;


        browserHistory.push({
			pathname: this.props.location.pathname,
			query,
		});
	}

	componentDidMount() {
		const isBuyerStateBreakdown = this.props.location.pathname === buyerStateBreakdownRoute;
        const isTransactionBreakdown = this.props.location.pathname === transactionBreakdownRoute;
        const isMarketTransactionBreakdown = this.props.location.pathname === marketTransactionBreakdownRoute;
        const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown;
        this.setState({
			isBreakdown,
			buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
			transactionBreakdownCheckbox: isTransactionBreakdown,
            marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
        });
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.location.query !== nextProps.location.query) {
            const isBuyerStateBreakdown = nextProps.location.pathname === buyerStateBreakdownRoute;
            const isTransactionBreakdown = nextProps.location.pathname === transactionBreakdownRoute;
            const isMarketTransactionBreakdown = nextProps.location.pathname === marketTransactionBreakdownRoute;
            const isBreakdown = isBuyerStateBreakdown || isTransactionBreakdown || isMarketTransactionBreakdown;
            const query = {...nextProps.location.query};
			delete query.page;
			this.setState({
				query,
				isBreakdown,
				buyerStateBreakdownCheckbox: isBuyerStateBreakdown,
                transactionBreakdownCheckbox: isTransactionBreakdown,
                marketTransactionBreakdownCheckbox: isMarketTransactionBreakdown,
            });
		}
	}

    clear() {
        window.scrollTo(0, 0);
        if (!this.props.isSuper && this.props.location.pathname === '/buyers') {
            browserHistory.push(`${arc.path.base}buyers?STATUS=1031-Buyer%2CActive`)
        } else {
            browserHistory.push(this.props.location.pathname);
        }
    }

    handleDropdownChange(query, optionType, value, valueKey) {
        const transactionBreakdown = this.state.transactionBreakdownCheckbox;
        if (valueKey === 'TYPE') {
            delete query.SINGLE_TENANT_SUBCATEGORY;
            delete query.MULTI_TENANT_SUBCATEGORY;
            delete query.TENANT_ID;
            delete query.LEASE_TYPE;
        }

        if (valueKey === 'TYPE' && transactionBreakdown) {
            if (query.TYPE === 'MT') {
                query.SOLD_PRICE_MIN = 400000;
                query.SQFT_MIN = 5000;
            } else {
                delete query.SOLD_PRICE_MIN;
                delete query.SOLD_PRICE_MAX;
                delete query.SQFT_MIN;
                delete query.SQFT_MAX;
            }
        }

        if (valueKey === 'SOURCE' && query[valueKey] === 'HSC') {
            query.TRANSACTION_TYPE = 'Financing';
            query.HSC_STATUS = 'Courting,Loan In Process';
            delete query.STATUS;
        }

        if (valueKey === 'SOURCE' && query[valueKey] !== 'HSC') {
            delete query.HSC_STATUS;
        }

        this.setState({query});
    }

    handleChange(key, value) {
        const q = {
            [key]: value
        };

        if (key === 'TYPE') {
            q.SINGLE_TENANT_SUBCATEGORY = null;
            q.MULTI_TENANT_SUBCATEGORY = null;
            q.TENANT_ID = null;
            q.LEASE_TYPE = null;
        }

        this.setState({
            query: Object.assign(this.state.query, q),
        });
    }

    handleBreakdownChange(name) {
        const breakdownCheckbox = !this.state[name];
        let page = null;
        let query;

        switch (name) {
			case 'buyerStateBreakdownCheckbox':
				page = breakdownCheckbox ? 'buyerStateBreakdown' : null;
				query = Filter.getDefaultQuery(page);
				this.setState({query, buyerStateBreakdownCheckbox: breakdownCheckbox});
				break;
            case 'transactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'transactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({query, transactionBreakdownCheckbox: breakdownCheckbox});
                break;
            case 'marketTransactionBreakdownCheckbox':
                page = breakdownCheckbox ? 'marketTransactionBreakdown' : null;
                query = Filter.getDefaultQuery(page);
                this.setState({query, marketTransactionBreakdownCheckbox: breakdownCheckbox});
                break;
		}
    }

	setValue(updates) {
		this.setState({query: {...this.state.query, ...updates}});
	}

	close() {
		this.refs.searchPanel.close();
	}

	getValuesForDropdown(query, options, key, type='multiple') {
		if (!query || !options || query.length === 0 ) {
			return [];
        }

		let formattedQueryValues = query.split(',');
		let response = [];
		options.forEach((el) => {
			if (!key) {
				if (formattedQueryValues.includes(el)) {
					response.push(el)
				}
			} else {
				if (formattedQueryValues.includes(el[key])) {
					response.push(el)
				}
			}
		});

		if (!response) {
			return [];
        }
		if (type === "multiple") {
			return response;
		}
		return response[0] ? response[0] : null;
	}

    navigateTo(pathname) {
        const {isBreakdown, query} = this.state;
        if (isBreakdown) {
            const q = Filter.getDefaultQuery();
            this.setState({
				query: q,
				isBreakdown: !isBreakdown,
				buyerStateBreakdownCheckbox: false,
				transactionBreakdownCheckbox: false,
                marketTransactionBreakdownCheckbox: false,
            });
            browserHistory.push({
                pathname,
                query: q,
            });
            return;
        }

        browserHistory.push({
            pathname: pathname,
            query,
        });
	}
}
